import LandingPage from './landingPageComponent';

import { dispatch } from '../../store/store-utils';
import { updateCsrf } from '../../store/reducers/initialdata-reducer';

window.customElements.define('au-landing-page', LandingPage);

window.univ = JSON.parse(document.querySelector('#temp').children[0].innerHTML);

const csrfToken = document.querySelector('#csrf_token').innerHTML;

const csrfHeader = document.querySelector('#csrf_header').innerHTML;

dispatch(
  updateCsrf({
    csrfToken: `${csrfToken}`,
    csrfHeader: `${csrfHeader}`
  })
);
document.getElementById('csrf_header').remove();
document.getElementById('csrf_token').remove();

document
  .querySelector('au-landing-page')
  .setAttribute('semanticname', window.univ.semanticName);

if (window.univ.superAdmin && window.univ.superAdmin === true) {
  document.querySelector('body').classList.add('admin');
  document.querySelector('au-landing-page').setAttribute('mode', 'edit');
} else {
  document.querySelector('au-landing-page').setAttribute('mode', 'view');
}
